import React, { useEffect, useState } from 'react';
import getObject from '../utils/getObject';

export default function RealTimePreview({
  customizationData,
  formikValues,
  RTP
}) {
  const [player, setPlayer] = useState({ name: '', number: '' });

  useEffect(() => {
    let isMounted = true;

    if (customizationData) {
      if (isMounted) setPlayer({ name: '', number: '' });

      if (formikValues?.player_flag) {
        const { name, number } = getObject(
          customizationData,
          'value',
          formikValues.player_flag
        );

        if (isMounted)
          // We replace '([string])' with '', as some Player Flag names has additional information, e.g. '4 Virgil (Cup Print)'.
          setPlayer({ name: name.replace(/ *\([^)]*\) */g, ''), number });
      }

      if (formikValues?.name || formikValues?.number) {
        const { name, number } = formikValues;
        if (isMounted) setPlayer({ name, number });
      }
    }

    return () => {
      isMounted = false;
    };
  }, [formikValues]);

  if (RTP)
    return (
      <svg
        className="absolute top-0 z-20"
        width="300"
        height="300"
        viewBox="0 0 300 300"
      >
        <defs>
          <path
            id="namePath"
            d={
              RTP.BNAM.curved
                ? 'M104 87.5V87.5C126.558 55.5529 173.942 55.5529 196.5 87.5V87.5'
                : 'M83 63L218 63'
            }
          />
          <path id="numberPath" d="M104 170.5H150.25H196.5" />
        </defs>
        <text
          fill={RTP.BNAM.color}
          fontFamily={RTP.BNAM.fontName}
          fontSize={RTP.BNAM.size / ((player?.name?.length || 0) * 0.025 + 1)}
          letterSpacing={-0.5}
        >
          <textPath xlinkHref="#namePath" textAnchor="middle" startOffset="50%">
            {player?.name?.toUpperCase() || ''}
          </textPath>
        </text>
        <text
          fill={RTP.BNUM.color}
          fontFamily={RTP.BNUM.fontName}
          fontSize={RTP.BNUM.size}
        >
          <textPath
            xlinkHref="#numberPath"
            textAnchor="middle"
            startOffset="50%"
          >
            {player?.number || ''}
          </textPath>
        </text>
      </svg>
    );

  return null;
}
